import { knowledgeBaseTypes } from './knowledgeBase.types';

// GET
export const getKnowledgeBaseData = (channelId) => ({
  type: knowledgeBaseTypes.GET_KNOWLEDGE_BASE_DATA,
  payload: channelId,
});

export const getKnowledgeBaseDataSuccess = (data) => ({
  type: knowledgeBaseTypes.GET_KNOWLEDGE_BASE_DATA_SUCCESS,
  payload: data,
});

export const getKnowledgeBaseDataFailure = (error) => ({
  type: knowledgeBaseTypes.GET_KNOWLEDGE_BASE_DATA_FAILURE,
  payload: error,
});

// PUT
export const putKnowledgeBaseData = (channelId, data) => ({
  type: knowledgeBaseTypes.PUT_KNOWLEDGE_BASE_DATA,
  payload: { channelId, data },
});

export const putKnowledgeBaseDataSuccess = (data) => ({
  type: knowledgeBaseTypes.PUT_KNOWLEDGE_BASE_DATA_SUCCESS,
  payload: data,
});

export const putKnowledgeBaseDataFailure = (error) => ({
  type: knowledgeBaseTypes.PUT_KNOWLEDGE_BASE_DATA_FAILURE,
  payload: error,
});
